<template>

    <newOnboardingLayout>

        <template #left>
            <div class="text-xl mt-8">
                Create a Free Account
            </div>

            <ul class="list-disc mt-2 pl-4 mb-2">
                <li>14 day trial</li>
                <li>50 free outgoing message credits</li>
                <li>Explore all features</li>
            </ul>
            <div class="lg:text-xs italic mb-8">
                * During your trial you will only be allowed to message up to {{ $page.props.trial_contact_limit }} contacts.
                <a href="https://textspot.io/resources/a2p-guide/#How_does_my_trial_work_if_I_have_not_been_A2P_verified"
                    target='_blank' class="text-blue-500 font-bold cursor-pointer">Learn why</a>.
            </div>

            <div class="hidden lg:block">
                <span class="text-gray-500 bg-gray-300 border rounded-full text-xs p-2 pl-4 pr-4 mb-2">STEP 1</span>
                <div class="mb-8 mt-4">
                    Provide your name, email, password and verify your account with your personal phone number.
                </div>
            </div>

            <span class="text-white font-bold bg-blue-500 border rounded-full text-xs p-2 pl-4 pr-4">STEP 2</span>
            <div class="lg:mb-8 mt-4">Get access to TextSpot and try it out!</div>

            <div class="hidden lg:block">
                <span class="font-bold text-gray-700 bg-gray-300 border rounded-full text-xs p-2 pl-4 pr-4">
                    STEP 3
                </span>
                <div class="mb-8 mt-4">
                    Upgrade your account to get your own phone number and start messaging your contacts.
                    <strong>Start for just $29 + a one time carrier registration fee of $19. Cancel anytime.</strong><br />

                    <a href="https://textspot.io/resources/30-day-money-back-guarantee-policy/" target='_blank'
                        class="text-blue-500 cursor-pointer font-bold">
                        Learn about our 30-day money-back guarantee.
                    </a>
                </div>
            </div>

        </template>

        <template #center>
            <form @submit.prevent="submitForm">
                <div>
                    <div class="mt-4">
                        <label class="block font-medium text-sm text-gray-700">
                            Account/Organization Name
                        </label>
                        <input v-model='form.account_name' class="form-input rounded-md shadow-sm block mt-1 w-full"
                            type="text" name="account_name" required="required" autofocus="autofocus"
                            autocomplete="name" placeholder="Acme Inc">
                        <p class="text-xs text-gray-800 mt-2">Your account name will be shown to your contacts (for
                            various compliance reasons during opt-in/opt-out). Please ensure your account name is
                            something your contacts will recognize.</p>
                        <div v-if="errors.message"
                            class="bg-red-100 border border-red-400 text-red-700  p-2 mt-2 mb-2">
                            {{ errors.message }}
                        </div>
                        <div class="flex items-center justify-end mt-4">
                            <jet-button :loading="loading">
                                Start Trial
                            </jet-button>
                        </div>
                        <div v-if="error_message"
                            class="bg-red-100 border border-red-400 text-red-700  p-2 mt-2 mb-2">
                            {{ error_message }}
                        </div>
                    </div>
                </div>
            </form>
        </template>
    </newOnboardingLayout>

</template>


<script>
import ApplicationMark from "../../Jetstream/ApplicationMark";
import JetButton from "../../Jetstream/Button";
import newOnboardingLayout from "../../Layouts/NewOnboardingLayout";

export default {
    name: 'registerPage',
    components: {
        ApplicationMark, JetButton, newOnboardingLayout,
    },
    data: () => ({
        form: {
            account_name: '',
            csrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
        },
        loading: false,
        errors: {},
        error_message: "",
        showPhoneNumberValidationError: false,
    }),
    computed: {
    },
    methods: {
        submitForm() {

            // account name must be at least 3 characters
            if (this.form.account_name.trim().length < 3) {
                this.error_message = "Account name must be at least 3 characters";
                return;
            }

            this.loading = true;
            this.errors = {};
            this.error_message = "";
            axios.post(route('newOnboarding'), this.form)
            .then(response => {
                try {
                  window.dataLayer.push({
                    event: "completed-new-onboarding"
                  });
                } catch (e) {}
                window.location.href = route('dashboard');
            })
            .catch(error => {
                this.loading = false;
                if (error.response.status === 419) {
                    this.error_message = "Form is expired";
                } else {
                    this.errors = error.response.data.errors;
                    if (Array.isArray(error.response.data.message)) {
                        this.error_message = error.response.data.message[0];
                    } else {
                        this.error_message = error.response.data.message;
                    }
                }
            });
        },
        phoneNumberUpdate(val) {
        },

    }
}
</script>


<style scoped>


</style>
